<div
  class="file-upload-dropzone flex flex-col gap-3 rounded-2xl bg-lGray900 p-8"
  [class.file-upload-dropzone--dashed]="dashedBorder"
>
  <div class="file-upload-icon-bubble mx-auto inline-flex h-24 w-24 items-center justify-center rounded-full text-lWhite">
    @if (status === 'uploading' || status === 'idle') {
      <l-icon class="!text-5xl">backup</l-icon>
    } @else {
      <l-icon class="!text-5xl">check</l-icon>
    }
  </div>

  <div class="text-center">
    @if (status === 'uploading') {
      <p class="text-lg font-medium leading-10 text-lWhite">{{ uploadingTitle }}</p>
      @for (hint of uploadingHints; track hint) {
        <p class="mt-2 text-sm leading-5 text-lGray500">{{ hint }}</p>
      }
    } @else if (status === 'uploaded') {
      <p class="text-lg font-medium leading-10 text-lWhite">{{ uploadedTitle }}</p>
      @if (fileName) {
        <p class="mt-2 text-sm leading-5 text-lGray500">
          {{ fileName }}@if (fileSizeLabel) { ({{ fileSizeLabel }})}
        </p>
      }
    } @else {
      <p class="text-lg font-medium leading-10 text-lWhite">{{ idleTitle }}</p>
      @for (hint of idleHints; track hint) {
        <p class="mt-2 text-sm leading-5 text-lGray500">{{ hint }}</p>
      }
    }
  </div>

  <input
    #fileInput
    [id]="inputId"
    type="file"
    [accept]="accept"
    class="hidden"
    (change)="onFileInputChange($event)"
  />

  @if (status === 'uploading') {
    <div class="mx-auto mt-2 h-3 w-full max-w-sm overflow-hidden rounded-full">
      <l-loading-bar />
    </div>
  } @else if (status === 'uploaded' && uploadedActions === 'delete-and-replace') {
    <div class="mx-auto mt-2 flex flex-wrap items-center justify-center gap-3">
      <button
        type="button"
        lButton
        [bType]="buttonTypeEnum.DANGER"
        [bRadius]="buttonRadiusEnum.CIRCLE"
        [bSize]="buttonSizeEnum.MEDIUM"
        class="mx-auto !h-12 !min-w-0 !gap-2 !px-8 !text-lg !font-medium"
        (click)="onDeleteClick()"
      >
        Excluir
        <l-icon class="text-lg">delete</l-icon>
      </button>

      <button
        type="button"
        lButton
        [bType]="buttonTypeEnum.PRIMARY"
        [bRadius]="buttonRadiusEnum.CIRCLE"
        [bSize]="buttonSizeEnum.MEDIUM"
        class="mx-auto !h-12 !min-w-0 !gap-2 !px-8 !text-lg !font-medium"
        (click)="openFilePicker()"
      >
        {{ replaceButtonLabel }}
        <l-icon class="text-lg">autorenew</l-icon>
      </button>
    </div>
  } @else {
    <button
      type="button"
      lButton
      [bType]="buttonTypeEnum.PRIMARY"
      [bRadius]="buttonRadiusEnum.CIRCLE"
      [bSize]="buttonSizeEnum.MEDIUM"
      class="mx-auto !h-12 !min-w-0 !gap-2 !px-8 !text-lg !font-medium"
      (click)="openFilePicker()"
    >
      {{ actionButtonLabel }}
      <l-icon class="text-lg">{{ status === 'uploaded' ? 'autorenew' : 'upload' }}</l-icon>
    </button>
  }
</div>
